import { Search } from './../../shared/user.model';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { DISABLED } from '@angular/forms/src/model';
import { Register } from '../../shared/user.model';
import { NgForm } from '@angular/forms';
//import { UserService } from '../../shared/user.service';
import { RegistrationService } from '../../registration.service';
import { Router } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';
import swal from 'sweetalert2';
declare var $: any;
import { debugOutputAstAsTypeScript } from '@angular/compiler';



@Component({
  selector: 'app-approvals-grid',
  templateUrl: './approvals-grid.component.html',
  styleUrls: ['./approvals-grid.component.css']
})
export class ApprovalsGridComponent implements OnInit {
  isHidden: boolean =false;
  maintitle = "SchemesApprovals";
  title = "Applications List";
  sainikSchemeApplications = null;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  totalItems: number;
  isSearch: boolean;
  s: Search;
  userName: string;
  message : boolean;
  Action: string;
  data: any;
  applicationId: any;
  STATUS: any;
  d: any = {};
  userlist: any = [];
  approval: any = {};
  WorkflowId: any;
  FromUserId: any;
  ToUserId: any;
  formInvalid: boolean;
  statuss: any = {};
  RoleName: string;
  stage: any;
  id: any;
  e: any = {};
  r: any = {};
  w: any = {};
  m: any = {};
  Relegions: any = [];
  dependents: any = [];
  sg: any = {};
  cf: any = {};
  emp: any = {};
  hg: any = {};
  signatureimageUrl: any;
  thumbimpressionimageUrl: any;
  esmsignatureimageUrl: any;
  issuingauthoritysignatureimageUrl: any;
  dirsignatureimageUrl: any;
  myDate = new Date();
  ESMSignaturePath: any;
  PPoUploadPath: any;
  PropertpapersUploadPath: any;
  UploadMarksSheetPath: any;
  UploadRecordOfficeDocPath: any;
  UploadDischargeBookPath: any;
  UploadSSLCMarksSheetPath: any;
  UploadCETapplicationPath: any;
  Daughter_TCPath: any;
  signatureofapplicantmarriagegrantimageUrl: any;
  leftthumbimpressionimageUrl: any;
  signatureOfapplicantimageUrl: any;
  rightthumbimpressionimageUrl: any;
  signatureofapplicantwidowsimageUrl: any;
  modeform: string;
  Formdisable: boolean = false;
  approvallist: any;
  disableview: string;
  //click : boolean = true;
  mode : any;
  sgs: any={};
  cs: any ={};
  gn: any={};
  drg: any={};
  ca: any={};
  arg: any={};
  DaughterNamesList: any=[];
  rd:any={};
  constructor(private userService: RegistrationService, private router: Router, private errorHandler: ErrorHandler) {
    this.s = new Search();
    this.isSearch = false;
    this.userName = localStorage.getItem("userName");
    //rolename
    this.RoleName = localStorage.getItem("userRole");
    
  }
  ngOnInit() {
    this.Action = "Pending";
    this.title = "Applications Action Pending With " + this.userName;
    this.GetAllApplicationsToActByTheUser(this.itemsPerPage, 1);
    //rdo.checked=true;
    //this.GetAllUsersForSchemeapprovals();
  }



  SetUrl(applicationId: any, mode: any) {
    localStorage.setItem('applicationId', applicationId);
    localStorage.setItem('mode', mode);
  }


  pageChanged(pageNumber: number) {
    
    if (this.s.SearchText != "" && this.s.SearchText != null && this.s.SearchCriteria != "" && this.s.SearchCriteria != null) {
      this.isSearch = true;
    }
    else {
      this.isSearch = false;
    }
    if (this.isSearch)
      this.onSearch(this.s, this.itemsPerPage, pageNumber);
    else {
      //var values = (<HTMLInputElement>document.querySelector('input[name="Action"]:checked')).value;
      var values;
      // if (values == "Pending") {
      this.title = "Applications Action Pending With " + this.userName;
      this.GetAllApplicationsToActByTheUser(this.itemsPerPage, pageNumber);
      // }
      // if (values == "Others") {
      //   this.title = "Applications Action Pending With Others";
      //   this.GetAllApplicationToActByOthers(this.itemsPerPage, pageNumber);
      // }
      // if (values == "Closed") {
      //   this.title = "Applications Approved/Rejected";
      //   this.GetAllApplicationsClosed(this.itemsPerPage, 1);
      // }
    }
  }

  itemsPerPageChanged(itemsPerPage: number, pageNo: number) {
    if (this.s.SearchText != "" && this.s.SearchText != null && this.s.SearchCriteria != "" && this.s.SearchCriteria != null) {
      this.isSearch = true;
    }
    else {
      this.isSearch = false;
    }
    if (this.isSearch)
      this.onSearch(this.s, this.itemsPerPage, pageNo);
    else {
      //var values = (<HTMLInputElement>document.querySelector('input[name="Action"]:checked')).value;
      //if (values == "Pending") {
        this.title = "Applications Action Pending With " + this.userName;
        this.GetAllApplicationsToActByTheUser(this.itemsPerPage, pageNo);
     // }
      // if (values == "Others") {
      //   this.title = "Applications Action Pending With Others"
      //   this.GetAllApplicationToActByOthers(this.itemsPerPage, pageNo);
      // }
      // if (values == "Closed") {
      //   this.title = "Applications Approved/Rejected";
      //   this.GetAllApplicationsClosed(this.itemsPerPage, 1);
      // }
    }
  }

  GetAllApplicationsToActByTheUser(itemsPerPage: number, pageNo: number) {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getAllApplicationsToBeApprovedByTheUser(itemsPerPage, pageNo)
      .subscribe(
        (data: any) => {
          this.sainikSchemeApplications = data.sainikSchemeApplicationModels;

          console.log('app data :' + JSON.stringify(data.sainikSchemeApplicationModels));
          // for(var i=0; i<this.sainikSchemeApplications.length;i++)
          // {
          // this.userlist=this.sainikSchemeApplications[i].ApprovalUserList;
          // }
          this.totalItems = data.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  onItemChange(radioSelected: string) {
    if (radioSelected == "Pending") {
      this.title = "Applications Action Pending With " + this.userName;
      this.GetAllApplicationsToActByTheUser(this.itemsPerPage, 1);
    }
    if (radioSelected == "Others") {
      this.title = "Applications Action Pending With Others";
      this.GetAllApplicationToActByOthers(this.itemsPerPage, 1);
    }
    if (radioSelected == "Closed") {
      this.title = "Applications Approved/Rejected";
      this.GetAllApplicationsClosed(this.itemsPerPage, 1);
    }
  }

  GetAllApplicationToActByOthers(itemsPerPage: number, pageNo: number) {

    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getAllApplicationsToBeApprovedByOthers(itemsPerPage, pageNo)
      .subscribe(
        (data: any) => {
          this.sainikSchemeApplications = data.sainikSchemeApplicationModels;
          this.totalItems = data.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }
  GetAllApplicationsClosed(itemsPerPage: number, pageNo: number) {

    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getAllApplicationsClosed(itemsPerPage, pageNo)
      .subscribe(
        (data: any) => {
          this.sainikSchemeApplications = data.sainikSchemeApplicationModels;
          this.totalItems = data.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }
  onSearch(s, itemsPerPage: number, pageNo: number) {
    var searchText = this.s.SearchText;
    var searchCriteria = this.s.SearchCriteria;
    if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
      swal("Warning!", "Please enter the search criteria and search text.", "warning");
    else {
      document.getElementById('loader-spinner').style.display = "block";
      //var values = (<HTMLInputElement>document.querySelector('input[name="Action"]:checked')).value;
      var values = "Pending";
      this.userService.searchApplications(searchCriteria, searchText, itemsPerPage, pageNo, values)
        .subscribe(
          (data: any) => {
            this.sainikSchemeApplications = data.sainikSchemeApplicationModels;
            this.totalItems = data.TotalItemsCount;
            this.itemsPerPage = itemsPerPage;
            this.currentPage = pageNo;
            document.getElementById('loader-spinner').style.display = "none";
          }, (error: any) => {
            document.getElementById('loader-spinner').style.display = "none";
            this.errorHandler.HandlerError(error);
          });
    }
  }



  handleChange2(applicationId) {
    this.applicationId = applicationId;
    this.STATUS = 9;
    this.SchemeApplicationApprovalStatus(this.applicationId)
  }

  handleChangeApproval(applicationId, j, workflowId, Stages, SchemeApprovalDetailsListView) {
    
    this.disableview = "";
    //this.click = true;
    this.applicationId = applicationId;
    this.STATUS = 11;
    this.WorkflowId = workflowId;
    this.stage = Stages;
    for (var i = 0; i < this.sainikSchemeApplications.length; i++) {
      if (i == j) {
        this.userlist = this.sainikSchemeApplications[i].ApprovalUserList;
        this.approval = {};
        if (this.sainikSchemeApplications[i].SchemeApprovalDetailsListView.length != 0) {
          this.approval.ToUserId = SchemeApprovalDetailsListView[0].ToUserId;
          this.approval.ApprovalStatus = SchemeApprovalDetailsListView[0].ApprovalStatus;
          this.approval.Description = SchemeApprovalDetailsListView[0].Description;
          this.disableview = "A";
          //this.click = true;
          
        }
        break;
      }
    }

  }

  handleChangeReject(applicationId, fromUserId, toUserId) {
    
    this.applicationId = applicationId;
    this.STATUS = 11;
    this.FromUserId = fromUserId;
    this.ToUserId = toUserId;
  }


  handleChange1(applicationId) {
    
    this.applicationId = applicationId;
    this.STATUS = 11;
  }


  // Scheme Approval Reject
  SchemeApplicationApprovalStatus(applicationId) {
    this.data = this.userService.updateSchemeApprovalStatus(this.applicationId, this.STATUS, this.d.Comments, this.FromUserId);
    this.data.subscribe(
      (response) => {
        swal('Success!', 'Status Updated Successfully .', 'success');
        this.closeModalDialog();
        this.GetAllApplicationsToActByTheUser(this.itemsPerPage, 1);
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401 || error.status == 500) {
          this.errorHandler.HandlerError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.Message, 'warning');
        }
      });

  }


  closeModalDialog() {
    $(".bd-example-modal-xl").modal('hide');
  }

  //GetAllUsers For SchemeApprovals
  //  GetAllUsersForSchemeapprovals()
  //     {
  //       document.getElementById('loader-spinner').style.display = "block";
  //       this.userService.getAllUsersForSchemeApprovals()
  //         .subscribe(
  //           (data) => {
  //             this.userlist = data;
  //             //swal("warning",this.sainikSchemeApplicationModel.ID);
  //             document.getElementById('loader-spinner').style.display = "none";
  //           }, (error) => {
  //             document.getElementById('loader-spinner').style.display = "none";
  //             this.errorHandler.HandlerError(error);
  //         });
  //     }


  //Update Application Status Approved
  SaveSchemeApplicationApproved(approval: NgForm) {
    
    if ((this.approval.ApprovalStatus == "Rejected") && ((this.approval.Description == null) || (this.approval.Description == undefined)
      || (this.approval.Description == ""))) {

      swal('Warning!', 'Please give Remarks.', 'warning');
      return;
    }
    if (approval.valid) {
      this.formInvalid = false;
    this.approval.SainikWorkflowId = this.WorkflowId;
    this.approval.Stage = this.stage;
    this.data = this.userService.saveSchemeApplicationApproved(this.applicationId, this.approval);
    this.data.subscribe(
      (response) => {
        swal('Success!', 'Approved Successfully .', 'success');
        this.closeModalDialogOFApproved();
        this.approval = {};
        this.isHidden = true;
        this.GetAllApplicationsToActByTheUser(this.itemsPerPage, 1);
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401 || error.status == 500) {
          this.errorHandler.HandlerError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.Message, 'warning');
        }
      });
    //  }
    //  else{
    //       swal('Warning!', 'Please give Remarks.', 'warning');
     }
      else {
        //  swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
         swal('Warning!', 'Please fill the mandatory(*) fields.', 'warning');
        this.formInvalid = true;
      }

  }


  closeModalDialogOFApproved() {
    $(".bd-approve-modal-xl").modal('hide');
  }


  // GetSainikApplicationStatus()
  // {
  //   document.getElementById('loader-spinner').style.display = "block";
  //   this.userService.getSainikApplicationStatus()
  //     .subscribe(
  //       (data) => {
  //         this.statuss = data;
  //         //swal("warning",this.sainikSchemeApplicationModel.ID);
  //         document.getElementById('loader-spinner').style.display = "none";
  //       }, (error) => {
  //         document.getElementById('loader-spinner').style.display = "none";
  //         this.errorHandler.HandlerError(error);
  //     });
  // }

  // View  form modals

  openModalDialog(id, name, serviceNo) {
    
    this.id = id;
    if (id == 1) {
      $("#ApplicationForm1").modal('show');
      this.GetSainikDetailsForDependentIdCard(serviceNo);
      this.Formdisable = true;
    }
    else if (id == 2) {
      $("#ApplicationForm2").modal('show');
      this.modeform = "disable";
      this.GetExServiceManIdCardDetails(serviceNo);
      this.Formdisable = true;
    }
    else if (id == 3) {
      $("#ApplicationForm3").modal('show');
      this.GetWidowIdCardDetails(serviceNo);
      this.Formdisable = true;
    }
    else if (id == 4) {
      $("#ApplicationForm4").modal('show');
      this.GetMarriageGrantOfDaughterFormDetails(serviceNo);
      this.Formdisable = true;
    }
    else if (id == 10) {
      $("#ApplicationForm5").modal('show');
      this.GetDetailsForSpectacleGrantForm(serviceNo);
      this.Formdisable = true;
    }
    else if (id == 11) {
      $("#ApplicationForm6").modal('show');
      this.GetDetailsForCETCertificateForm(serviceNo);
      this.Formdisable = true;
    }
    else if (id == 12) {
      $("#ApplicationForm7").modal('show');
      this.GetDetailsForEmploymentRegistrationform(serviceNo);
      this.Formdisable = true;
    }

    else if (id == 1008) {
      $("#ApplicationForm8").modal('show');
      this.GetDetailsForHouseRepairGrantform(serviceNo);
      this.Formdisable = true;
    }

//Second time
    else if (id == 2009) {
      $("#ApplicationForm9").modal('show');
      this.GetDetailsForStateGovtScholarshipform(serviceNo);
      this.Formdisable = true;
    }

    else if (id == 2010) {
      $("#ApplicationForm10").modal('show');
      this.GetDetailsForChildrenGrantScholarshipform(serviceNo);
      this.Formdisable = true;
    }

    else if (id == 2011) {
      $("#ApplicationForm11").modal('show');
      this.GetDetailsForGallantryNonGallantryform(serviceNo);
      this.Formdisable = true;
    }

    else if (id == 2012) {
      $("#ApplicationForm12").modal('show');
      this.GetDetailsForDeathReliefGrantform(serviceNo);
      this.Formdisable = true;
    }

    else if (id == 2013) {
      $("#ApplicationForm13").modal('show');
      this.GetDetailsForCashAwardform(serviceNo);
      this.Formdisable = true;
    }

    else if (id == 2014) {
      $("#ApplicationForm14").modal('show');
      this.GetDetailsForAnnualReliefGrantForm(serviceNo);
      this.Formdisable = true;
    }


//for staging
    // else if (id == 1009) {
    //   $("#ApplicationForm9").modal('show');
    //    this.GetDetailsForStateGovtScholarshipform(serviceNo);
    //    this.Formdisable = true;     
    // }
    // else if (id == 1010) {
    //   $("#ApplicationForm10").modal('show');
    //    this.GetDetailsForChildrenGrantScholarshipform(serviceNo);
    //    this.Formdisable = true;     
    // }
    // else if (id == 1011) {
    //   $("#ApplicationForm11").modal('show');
    //    this.GetDetailsForGallantryNonGallantryform(serviceNo);
    //    this.Formdisable = true;      
    // }
    // else if (id == 1012) {
    //   $("#ApplicationForm12").modal('show');
    //      this.GetDetailsForDeathReliefGrantform(serviceNo);
    //     this.Formdisable = true;     
    // }
    // else if (id == 1013) {
    //   $("#ApplicationForm13").modal('show');
    //      this.GetDetailsForCashAwardform(serviceNo);
    //     this.Formdisable = true;      
    // }
    // else if (id == 1014) {
    //   $("#ApplicationForm14").modal('show');
    //     this.GetDetailsForAnnualReliefGrantForm(serviceNo);
    //     this.Formdisable = true;    
    // }
  }

  GetSainikDetailsForDependentIdCard(serviceNo: any) {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getSainikDetailsForDependentIdCard(serviceNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.d = data;
          this.d.DID_AppliedDate = this.myDate;
          this.d.DID_DirAppliedDate = this.myDate;
          if (data.SR_DOB != null)
            this.d.SR_DOB = ((data.SR_DOB).split('T'))[0];
          if (data.SD_DOB != null)
            this.d.SD_DOB = ((data.SD_DOB).split('T'))[0];
          if (data.DateOfjoinedService != null)
            this.d.DateOfjoinedService = ((data.DateOfjoinedService).split('T'))[0];
          if (data.DateOfRetirement != null)
            this.d.DateOfRetirement = ((data.DateOfjoinedService).split('T'))[0];
          if (data.DependentIdValidUpTo != null)
            this.d.DependentIdValidUpTo = ((data.DependentIdValidUpTo).split('T'))[0];
          if (data.DependentIdIssuedOn != null)
            this.d.DependentIdIssuedOn = ((data.DependentIdIssuedOn).split('T'))[0];
          if (data.DependentSignature != null)
            this.signatureimageUrl = data.DependentSignaturePath;
          if (data.DependentThumbImpression != null)
            this.thumbimpressionimageUrl = data.DependentThumbImpressionPath;
          if (data.ESMSignature != null)
            this.esmsignatureimageUrl = data.ESMSignaturePath;
          if (data.DirSignature != null)
            this.dirsignatureimageUrl = data.DirSignaturePath;
          if (data.IssuingAuthoritySignature != null)
            this.issuingauthoritysignatureimageUrl = data.IssuingAuthoritySignaturePath;

          if (data.DID_AppliedDate != null)
            this.d.DID_AppliedDate = ((data.DID_AppliedDate).split('T'))[0];
          if (data.DID_DirAppliedDate != null)
            this.d.DID_DirAppliedDate = ((data.DID_DirAppliedDate).split('T'))[0];

        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  //ExServiceManIdCard
  GetExServiceManIdCardDetails(serviceNo: any) {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getExServiceManIdCardDetails(serviceNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.e = data;
          this.e.ESMId_AppliedDate = this.myDate;
          this.dependents = data.SainikDependents;
          if (data.SR_DOB != null)
            this.e.SR_DOB = ((data.SR_DOB).split('T'))[0];
          if (data.SP_DischargeBookDate != null)
            this.e.SP_DischargeBookDate = ((data.SP_DischargeBookDate).split('T'))[0];
          if (data.SP_PPODate != null)
            this.e.SP_PPODate = ((data.SP_PPODate).split('T'))[0];
          if (data.SR_DischargeDate != null)
            this.e.SR_DischargeDate = ((data.SR_DischargeDate).split('T'))[0];
          if (data.DateOfEnrollment != null)
            this.e.DateOfEnrollment = ((data.DateOfEnrollment).split('T'))[0];
          if (data.leftThumbImpession != null)
            this.leftthumbimpressionimageUrl = data.leftThumbImpessionPath;
          if (data.SignatureOfApplicant != null)
            this.signatureOfapplicantimageUrl = data.SignatureOfApplicantPath;
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  //Widow Id Card
 GetWidowIdCardDetails(serviceNo:any) {
  
  document.getElementById('loader-spinner').style.display = "block";
  this.userService.getWidowIdCardDetails(serviceNo)
    .subscribe(
      (data: any) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.w = data;
        this.w.WidowID_AppliedDate=this.myDate;
        this.dependents = data.SainikDependents;
        if(data.DateOfDischarge!=null)
        this.w.DateOfDischarge=((data.DateOfDischarge).split('T'))[0];
        if(data.DateOfEnrollment!=null)
        this.w.DateOfEnrollment=((data.DateOfEnrollment).split('T'))[0];
        if(data.SR_DOD!=null)
        this.w.SR_DOD=((data.SR_DOD).split('T'))[0];
        if(data.WidowDOB!=null)
        this.w.WidowDOB=((data.WidowDOB).split('T'))[0];
        if(data.RightThumbImpession!=null)
        this.rightthumbimpressionimageUrl=data.RightThumbImpessionPath;
        if(data.SignatureofApplicant!=null)
        this.signatureofapplicantwidowsimageUrl=data.SignatureofApplicantPath;
        console.log("Widimg",this.signatureofapplicantwidowsimageUrl, this.rightthumbimpressionimageUrl);
        // this.w.SR_DOB=((data.SR_DOB).split('T'))[0];
        if(data.SP_PPODate!=null)
        this.w.SP_PPODate=((data.SP_PPODate).split('T'))[0];
        // this.w.SP_DischargeBookDate=((data.SP_DischargeBookDate).split('T'))[0];
        // this.w.SR_DOD=((data.SR_DOD).split('T'))[0];
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });
}


   //marriage grant form
   GetMarriageGrantOfDaughterFormDetails(serviceNo:any) {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getMarriageGrantOfDaughterFormDetails(serviceNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.m = data;
          // this.m.SR_DOB=((data.SR_DOB).split('T'))[0];
          // this.w.SP_PPODate=((data.SP_PPODate).split('T'))[0];
          // this.w.SP_DischargeBookDate=((data.SP_DischargeBookDate).split('T'))[0];
           //this.m.SR_DOD=((data.SR_DOD).split('T'))[0];
           this.m.MGrant_AppliedDate=this.myDate;
          if(data.Daughter_TC!=null)
          this.Daughter_TCPath=data.Daughter_TC;
           if(data.SignatureofApplicant!=null)
          this.signatureofapplicantmarriagegrantimageUrl=data.SignatureofApplicantPath;
          if(data.DateofEnrollement!=null)
          this.m.DateofEnrollement=((data.DateofEnrollement).split('T'))[0];
          if(data.DateofDischarge!=null)
          this.m.DateofDischarge=((data.DateofDischarge).split('T'))[0];

          if(data.SR_DOD!=null)
           this.m.SR_DOD=((data.SR_DOD).split('T'))[0];
           if(data.Daughter_DOB!=null)
           this.m.Daughter_DOB=((data.Daughter_DOB).split('T'))[0];
           if(data.Daughter_MarriageDate!=null)
           this.m.Daughter_MarriageDate=((data.Daughter_MarriageDate).split('T'))[0];
           if(data.Marriage_Date!=null)
           this.m.Marriage_Date=((data.Marriage_Date).split('T'))[0];
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }


  //spectacle grant form
  GetDetailsForSpectacleGrantForm(serviceNo: any) {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getDetailsForSpectacleGrantForm(serviceNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.sg = data;
          // this.m.SR_DOB=((data.SR_DOB).split('T'))[0];
          // this.w.SP_PPODate=((data.SP_PPODate).split('T'))[0];
          // this.w.SP_DischargeBookDate=((data.SP_DischargeBookDate).split('T'))[0];
          //this.m.SR_DOD=((data.SR_DOD).split('T'))[0];
          if (data.DateofDischarge != null)
            this.sg.DateofDischarge = ((data.DateofDischarge).split('T'))[0];
          if (data.DateofEnrollement != null)
            this.sg.DateofEnrollement = ((data.DateofEnrollement).split('T'))[0];
          if (data.SR_DOD != null)
            this.sg.SR_DOD = ((data.SR_DOD).split('T'))[0];
          //  if(data.Date!=null)
          //  this.sg.Date=((data.Date).split('T'))[0];
          this.sg.Date = this.myDate;
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  //GetDetailsForCETCertificateForm
  GetDetailsForCETCertificateForm(serviceNo: any) {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getDetailsForCETCertificateForm(serviceNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.cf = data;
          // this.m.SR_DOB=((data.SR_DOB).split('T'))[0];
          // this.w.SP_PPODate=((data.SP_PPODate).split('T'))[0];
          // this.w.SP_DischargeBookDate=((data.SP_DischargeBookDate).split('T'))[0];
          //this.m.SR_DOD=((data.SR_DOD).split('T'))[0];
          if (data.DateofEnrollement != null)
            this.cf.DateofEnrollement = ((data.DateofEnrollement).split('T'))[0];
          if (data.DateofDischarge != null)
            this.cf.DateofDischarge = ((data.DateofDischarge).split('T'))[0];
          if (data.Date != null)
            this.cf.Date = ((data.Date).split('T'))[0];
          if (data.UploadMarkSheets != null)
            this.UploadMarksSheetPath = data.UploadMarkSheetsPath;
          if (data.UploadRecordOfficeDoc != null)
            this.UploadRecordOfficeDocPath = data.UploadRecordOfficeDocPath;
          if (data.UploadDischargeBook != null)
            this.UploadDischargeBookPath = data.UploadDischargeBookPath;
          if (data.UploadSSLCMarksSheet != null)
            this.UploadSSLCMarksSheetPath = data.UploadSSLCMarksSheetPath;
          if (data.UploadCETApplication != null)
            this.UploadCETapplicationPath = data.UploadCETApplicationPath;
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  //GetDetailsForEmploymentRegistrationform
  GetDetailsForEmploymentRegistrationform(serviceNo: any) {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getDetailsForEmploymentRegistrationform(serviceNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.emp = data;
          // this.m.SR_DOB=((data.SR_DOB).split('T'))[0];
          // this.w.SP_PPODate=((data.SP_PPODate).split('T'))[0];
          // this.w.SP_DischargeBookDate=((data.SP_DischargeBookDate).split('T'))[0];
          //this.m.SR_DOD=((data.SR_DOD).split('T'))[0];
          if (this.emp.Date != null)
            this.emp.Date = ((data.Date).split('T'))[0];
          if (data.ESMSignature != null)
            this.ESMSignaturePath = data.ESMSignaturePath;

        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  //GetDetailsForHouseRepairGrantform
  GetDetailsForHouseRepairGrantform(serviceNo: any) {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getDetailsForHouseRepairGrantform(serviceNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.hg = data;
          // this.m.SR_DOB=((data.SR_DOB).split('T'))[0];
          // this.w.SP_PPODate=((data.SP_PPODate).split('T'))[0];
          // this.w.SP_DischargeBookDate=((data.SP_DischargeBookDate).split('T'))[0];
          //this.m.SR_DOD=((data.SR_DOD).split('T'))[0];
          if (this.hg.Date != null)
            this.hg.Date = ((data.Date).split('T'))[0];
          if (this.hg.DateofEnrollment != null)
            this.hg.DateofEnrollment = ((data.DateofEnrollment).split('T'))[0];
          if (this.hg.DateofInjuryorDeath != null)
            this.hg.DateofInjuryorDeath = ((data.DateofInjuryorDeath).split('T'))[0];
          if (this.hg.HandingOverDate != null)
            this.hg.HandingOverDate = ((data.HandingOverDate).split('T'))[0];
          if (data.UploadPPO != null)
            this.PPoUploadPath = data.UploadPPOPath;
          if (data.Uploadpropertypapers != null)
            this.PropertpapersUploadPath = data.UploadpropertypapersPath;
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

//second
  //appl9

  //GetDetailsForStateGovtScholarshipform
  GetDetailsForStateGovtScholarshipform(serviceNo:any) {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getDetailsForStateGovtScholarshipform(serviceNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.sgs = data;
           if(this.sgs.SGS_DOB!=null)
           this.sgs.SGS_DOB=((data.SGS_DOB).split('T'))[0];
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

   // appl10 GetDetailsForChildrenGrantScholarshipform
   GetDetailsForChildrenGrantScholarshipform(serviceNo:any) {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getDetailsForChildrenGrantScholarshipform(serviceNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.cs = data;
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

 // appl11 GetDetailsForGallantryNonGallantryform
 GetDetailsForGallantryNonGallantryform(serviceNo:any) {
  document.getElementById('loader-spinner').style.display = "block";
  this.userService.getDetailsForGallantryNonGallantryform(serviceNo)
    .subscribe(
      (data: any) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.gn = data;
        if(data.GNG_DateofCommission!=null)
        this.gn.GNG_DateofCommission=((data.GNG_DateofCommission).split('T'))[0];
        if(data.GNG_ReceivedDate!=null)
        this.gn.GNG_ReceivedDate=((data.GNG_ReceivedDate).split('T'))[0];
        if(data.GNG_grantDate!=null)
        this.gn.GNG_grantDate=((data.GNG_grantDate).split('T'))[0];
        if(data.GNG_Date!=null)
        this.gn.GNG_Date=((data.GNG_Date).split('T'))[0];
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });
}

  //appl12 GetDetailsForDeathReliefGrantform
  GetDetailsForDeathReliefGrantform(serviceNo:any) {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getDetailsForDeathReliefGrantform(serviceNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.drg = data;
          if(data.DRG_ExservicemanDeathDate!=null)
          this.drg.DRG_ExservicemanDeathDate=((data.DRG_ExservicemanDeathDate).split('T'))[0];
          if(data.DRG_Ex_Date!=null)
          this.drg.DRG_Ex_Date=((data.DRG_Ex_Date).split('T'))[0];
          if(data.DRG_Ex_JoiningDate!=null)
          this.drg.DRG_Ex_JoiningDate=((data.DRG_Ex_JoiningDate).split('T'))[0];
          if(data.DRG_Ex_RelievingDate!=null)
          this.drg.DRG_Ex_RelievingDate=((data.DRG_Ex_RelievingDate).split('T'))[0];
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }



 //appl13 GetDetailsForCashAwardform
 GetDetailsForCashAwardform(serviceNo:any) {
  document.getElementById('loader-spinner').style.display = "block";
  this.userService.getDetailsForCashAwardform(serviceNo)
    .subscribe(
      (data: any) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.ca = data;
        if(data.CATM_Date!=null)
        this.ca.CATM_Date=((data.CATM_Date).split('T'))[0];
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });
}


  //appl14 GetDetailsForAnnualReliefGrantForm
  GetDetailsForAnnualReliefGrantForm(serviceNo:any) {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getDetailsForAnnualReliefGrantForm(serviceNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.arg = data;
          if(data.ARG_RS_RelievingDate!=null)
          this.arg.ARG_RS_RelievingDate=((data.ARG_RS_RelievingDate).split('T'))[0];
          if(data.ARG_RS_JoingDate!=null)
          this.arg.ARG_RS_JoingDate=((data.ARG_RS_JoingDate).split('T'))[0];
          if(data.ARG_MDate!=null)
          this.arg.ARG_MDate=((data.ARG_MDate).split('T'))[0];
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  CancelHouseRepairIdDetails() {

  }
  UploadPropertypapersFileInputForHouseRepairgrantform() {

  }
  CancelEmpRegistrationIdDetails() {

  }
  SaveAllHouseRepairGrantform() {

  }
  UploadPPOFileInputForHouseRepairgrantform() {

  }
  ESMSignatureFileInputForEMPform(){
    
  }
}


// WEBPACK FOOTER //
// ./src/app/schemes/approvals-grid/approvals-grid.component.ts